"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hardDeleteSegment = exports.hasDataRows = exports.isXLSXFile = exports.isValidRowSize = exports.isValidFileSize = exports.restoreSegment = exports.deleteSegment = void 0;
const firestore_web_1 = require("comodel/firestore-web");
const models_1 = require("app/models");
const function_client_1 = require("@/utils/function-client");
const XLSX = __importStar(require("xlsx"));
const api_1 = require("@/schemaComponents/modules/copilotApi/api");
const MAX_FILE_SIZE = 1024 * 1024 * 10;
const MAX_ROWS = 5000;
function deleteSegment(segment) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const segmentAccessor = (0, firestore_web_1.documentAccessor)(models_1.segmentDefinition, {
            projectId: segment.projectId,
            segmentId: segment.segmentId,
        }, true);
        segmentAccessor.set(Object.assign(Object.assign({}, segment), { deletedAt: Date.now() }));
        const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, {
            projectId: segment.projectId,
            segmentId: segment.segmentId,
        }, {
            filter: {
                segmentId: segment.segmentId,
            },
        });
        const scripts = (_a = (yield accessor.get())) !== null && _a !== void 0 ? _a : [];
        yield (0, function_client_1.syncSegmentSearchDocuments)({
            projectId: segment.projectId,
            segmentId: segment.segmentId,
            scripts: scripts.map((script) => (Object.assign(Object.assign({}, script), { deletedAt: Date.now() }))),
            endpoint: (0, api_1.getApiEndPoint)(),
            type: "delete",
        });
    });
}
exports.deleteSegment = deleteSegment;
function restoreSegment(segment) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const segmentAccessor = (0, firestore_web_1.documentAccessor)(models_1.segmentDefinition, {
            projectId: segment.projectId,
            segmentId: segment.segmentId,
        }, true);
        segmentAccessor.set(Object.assign(Object.assign({}, segment), { deletedAt: undefined }));
        const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, {
            projectId: segment.projectId,
            segmentId: segment.segmentId,
        }, {
            filter: {
                segmentId: segment.segmentId,
            },
        });
        const scripts = (_a = (yield accessor.get())) !== null && _a !== void 0 ? _a : [];
        yield (0, function_client_1.syncSegmentSearchDocuments)({
            projectId: segment.projectId,
            segmentId: segment.segmentId,
            scripts: scripts.map((script) => (Object.assign(Object.assign({}, script), { deletedAt: undefined }))),
            endpoint: (0, api_1.getApiEndPoint)(),
            type: "update",
        });
    });
}
exports.restoreSegment = restoreSegment;
const isValidFileSize = (file_1, ...args_1) => __awaiter(void 0, [file_1, ...args_1], void 0, function* (file, maxFileSize = MAX_FILE_SIZE) {
    if (file.size <= maxFileSize)
        return null;
    return { error: true, message: "ファイルサイズが大きすぎます" };
});
exports.isValidFileSize = isValidFileSize;
const isValidRowSize = (file_2, ...args_2) => __awaiter(void 0, [file_2, ...args_2], void 0, function* (file, maxRows = MAX_ROWS) {
    const data = yield file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });
    let totalRowCount = 0;
    workbook.SheetNames.forEach((sheetName) => {
        const worksheet = workbook.Sheets[sheetName];
        const rowCount = XLSX.utils.sheet_to_json(worksheet).length;
        totalRowCount += rowCount;
    });
    if (totalRowCount <= maxRows)
        return null;
    return { error: true, message: "行数が多すぎます" };
});
exports.isValidRowSize = isValidRowSize;
const isXLSXFile = (file) => __awaiter(void 0, void 0, void 0, function* () {
    if (file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
        return null;
    return { error: true, message: "ファイルタイプが間違っています" };
});
exports.isXLSXFile = isXLSXFile;
const hasDataRows = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });
    // Check each sheet in the workbook
    for (const sheetName of workbook.SheetNames) {
        const worksheet = workbook.Sheets[sheetName];
        // Get rows with default options (header row is skipped by default)
        // This will only return data rows
        const dataRows = XLSX.utils.sheet_to_json(worksheet);
        // If there are no data rows, return error
        if (dataRows.length === 0) {
            return {
                error: true,
                message: "このファイルには翻訳データが含まれていません。別のファイルをお試しください。",
            };
        }
    }
    return null;
});
exports.hasDataRows = hasDataRows;
function hardDeleteSegment(segment) {
    return __awaiter(this, void 0, void 0, function* () {
        const segmentAccessor = (0, firestore_web_1.documentAccessor)(models_1.segmentDefinition, {
            projectId: segment.projectId,
            segmentId: segment.segmentId,
        }, true);
        // Perform both operations in parallel and wait for both to complete
        yield Promise.all([
            segmentAccessor.remove(),
            (0, function_client_1.replaceSegmentSearchDocuments)({
                projectId: segment.projectId,
                segmentId: segment.segmentId,
                scripts: [],
                endpoint: (0, api_1.getApiEndPoint)(),
            }),
        ]);
    });
}
exports.hardDeleteSegment = hardDeleteSegment;
